.container {
  display: var(--haus-priceFilter__container__display, block);
}

.fieldset {
  background-color: var(--haus-priceFilter__fieldset__background-color, #fff);
  border-bottom: var(
    --haus-priceFilter__fieldset__border-bottom,
    1px solid var(--haus-priceFilter__fieldset__border-color, rgba(0, 0, 0, 0.1))
  );
  border-top: var(--haus-priceFilter__fieldset__border-top, none);
  border-left: var(--haus-priceFilter__fieldset__border-left, none);
  border-right: var(--haus-priceFilter__fieldset__border-right, none);
  border-radius: var(--haus-priceFilter__fieldset__border-radius, 0);
  display: var(--haus-priceFilter__fieldset__display, flex);
  flex-direction: var(--haus-priceFilter__fieldset__flex-direction, column);
  gap: var(--haus-priceFilter__fieldset__gap, 12px);
  margin: var(--haus-priceFilter__fieldset__margin, 0);
  padding: var(--haus-priceFilter__fieldset__padding, 8px);
}

.filterTitle {
  align-items: var(--haus-priceFilter__filterTitle__align-items, center);
  background: var(--haus-priceFilter__filterTitle__background, transparent);
  border: var(--haus-priceFilter__filterTitle__border, none);
  border-radius: var(--haus-priceFilter__filterTitle__border-radius, 0);
  color: var(--haus-priceFilter__filterTitle__color, var(--haus-color-body));
  display: var(--haus-priceFilter__filterTitle__display, flex);
  font-family: var(
    --haus-priceFilter__filterTitle__font-family,
    var(--haus-typography-body-font-family)
  );
  font-size: var(--haus-priceFilter__filterTitle__font-size, 16px);
  font-weight: var(--haus-priceFilter__filterTitle__font-weight, 700);
  gap: var(--haus-priceFilter__filterTitle__gap, 8px);
  justify-content: var(--haus-priceFilter__filterTitle__justify-content, space-between);
  text-align: var(--haus-priceFilter__filterTitle__text-align, start);
  text-transform: var(--haus-priceFilter__filterTitle__text-transform, capitalize);
  width: var(--haus-priceFilter__filterTitle__width, 100%);
  margin: var(--haus-priceFilter__filterTitle__margin, 0);
  padding: var(--haus-priceFilter__filterTitle__padding, 0);
  padding-bottom: var(--haus-priceFilter__filterTitle__padding-bottom, 12px);
}

.currentRange {
  align-self: var(--haus-priceFilter__currentRange__align-self, center);
  color: var(--haus-priceFilter__currentRange__color, var(--haus-color-body));
  font-family: var(
    --haus-priceFilter__currentRange__font-family,
    var(--haus-typography-body-font-family)
  );
  font-size: var(--haus-priceFilter__currentRange__font-size, 14px);
  line-height: var(--haus-priceFilter__currentRange__line-height, 1.2);
  margin: var(--haus-priceFilter__currentRange__margin, 0);
  text-align: var(--haus-priceFilter__currentRange__text-align, center);
  padding: var(--haus-priceFilter__currentRange__padding, 8px 0 16px);
}

.sliderBlock {
  display: var(--haus-priceFilter__sliderBlock__display, block);
  padding: var(--haus-priceFilter__sliderBlock__padding, 4px 2px 0);
}

.sliderRoot {
  align-items: var(--haus-priceFilter__sliderRoot__align-items, center);
  cursor: var(--haus-priceFilter__sliderRoot__cursor, pointer);
  display: var(--haus-priceFilter__sliderRoot__display, flex);
  height: var(--haus-priceFilter__sliderRoot__height, 20px);
  position: var(--haus-priceFilter__sliderRoot__position, relative);
  user-select: var(--haus-priceFilter__sliderRoot__user-select, none);
  width: var(--haus-priceFilter__sliderRoot__width, 100%);
}

.sliderTrack {
  background-color: var(
    --haus-priceFilter__sliderTrack__background-color,
    var(--haus-color-border, #d0d5dd)
  );
  border-radius: var(--haus-priceFilter__sliderTrack__border-radius, 999px);
  flex-grow: var(--haus-priceFilter__sliderTrack__flex-grow, 1);
  height: var(--haus-priceFilter__sliderTrack__height, 4px);
  position: var(--haus-priceFilter__sliderTrack__position, relative);
}

.sliderRange {
  background-color: var(
    --haus-priceFilter__sliderRange__background-color,
    var(--haus-color-primary, #003a70)
  );
  border-radius: var(--haus-priceFilter__sliderRange__border-radius, 999px);
  height: var(--haus-priceFilter__sliderRange__height, 100%);
  position: var(--haus-priceFilter__sliderRange__position, absolute);
}

.sliderThumb {
  background-color: var(--haus-priceFilter__sliderThumb__background-color, #fff);
  border: var(
    --haus-priceFilter__sliderThumb__border,
    2px solid var(--haus-color-primary, #003a70)
  );
  border-radius: var(--haus-priceFilter__sliderThumb__border-radius, 50%);
  box-shadow: var(--haus-priceFilter__sliderThumb__box-shadow, 0 1px 3px rgb(0 0 0 / 20%));
  display: var(--haus-priceFilter__sliderThumb__display, block);
  height: var(--haus-priceFilter__sliderThumb__height, 16px);
  width: var(--haus-priceFilter__sliderThumb__width, 16px);

  &:focus-visible,
  &:focus {
    outline: var(
      --haus-priceFilter__sliderThumb__outline,
      2px solid var(--haus-color-primary, #003a70)
    );
    outline-offset: var(--haus-priceFilter__sliderThumb__outlineOffset, 2px);
  }
}

.inputs {
  display: var(--haus-priceFilter__inputs__display, grid);
  gap: var(--haus-priceFilter__inputs__gap, 10px);
  grid-template-columns: var(
    --haus-priceFilter__inputs__grid-template-columns,
    repeat(2, minmax(0, 1fr))
  );
}

.inputGroup {
  display: var(--haus-priceFilter__inputGroup__display, flex);
  flex-direction: var(--haus-priceFilter__inputGroup__flex-direction, column);
  gap: var(--haus-priceFilter__inputGroup__gap, 6px);
}

.label {
  color: var(--haus-priceFilter__label__color, var(--haus-color-body));
  font-family: var(--haus-priceFilter__label__font-family, var(--haus-typography-body-font-family));
  font-size: var(--haus-priceFilter__label__font-size, 14px);
  line-height: var(--haus-priceFilter__label__line-height, 1.2);
}

.input {
  appearance: var(--haus-priceFilter__input__appearance, textfield);
  background-color: var(--haus-priceFilter__input__background-color, #fff);
  border: var(
    --haus-priceFilter__input__border,
    1px solid var(--haus-priceFilter__input__border-color, var(--haus-color-border, #d0d5dd))
  );
  border-radius: var(--haus-priceFilter__input__border-radius, 6px);
  box-sizing: var(--haus-priceFilter__input__box-sizing, border-box);
  color: var(--haus-priceFilter__input__color, var(--haus-color-body));
  display: var(--haus-priceFilter__input__display, block);
  font-family: var(--haus-priceFilter__input__font-family, var(--haus-typography-body-font-family));
  font-size: var(--haus-priceFilter__input__font-size, 14px);
  line-height: var(--haus-priceFilter__input__line-height, 1.2);
  min-height: var(--haus-priceFilter__input__min-height, 44px);
  padding: var(--haus-priceFilter__input__padding, 10px);
  transition: var(--haus-priceFilter__input__transition, border-color 0.15s ease);
  width: var(--haus-priceFilter__input__width, 100%);

  &[type='number'] {
    appearance: var(--haus-priceFilter__input__number__appearance, textfield);
    -moz-appearance: var(--haus-priceFilter__input__moz-appearance, textfield);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: var(--haus-priceFilter__input__spinButton__appearance, none);
    -webkit-appearance: var(--haus-priceFilter__input__spinButton__webkit-appearance, none);
    margin: var(--haus-priceFilter__input__spinButton__margin, 0);
  }

  &:focus-visible,
  &:focus {
    border-color: var(
      --haus-priceFilter__input__focus__border-color,
      var(--haus-color-primary, #003a70)
    );
    outline: var(--haus-priceFilter__input__outline, 2px solid var(--haus-color-primary, #003a70));
    outline-offset: var(--haus-priceFilter__input__outlineOffset, 0);
  }
}
